import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import './i18n/i18n';
import App from './App/App';
import reportWebVitals from "./reportWebVitals";
import {Provider} from "react-redux";
import store from "./store";
import Loader from "./Components/Loader/Loader";

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
    <React.StrictMode>
        <Provider store={store.store}>
            <React.Suspense fallback={<Loader visible={true} />}>
                <App />
            </React.Suspense>
        </Provider>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

